//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixinTxrNewWeb from '@/utils/mixin/mixinTxrNewWeb'

export default {
    name: 'SuccessResult',
    mixins: [mixinTxrNewWeb],
    data() {
        return {
        }
    },
    computed: {
        channelCommodityCode(){
            return this.$route.query.channelCommodityCode
        },
    },
    mounted() {
        this.STATISTICS_CONFIG.insur_receive_success_page(); 
        // querySetTX 存储回溯参数
        this.querySetTX()

        this.operatingTX(this.channelCommodityCode)
    }
}
